import type { Labels } from '@@partner:types:app'
import type { GQL_ID } from '@@partner:types:graphql'

import { mergeLeft } from 'merge-left-utils'

export interface LabelFormTranslation {
  language_code: string
  name: string
  description: string
  option_link_label: string
  image_id?: GQL_ID
  image?: {
    url?: string
  }
}
export interface LabelFormState {
  id?: GQL_ID
  image_id?: GQL_ID
  system_name: string
  name: string
  description: string
  status: number
  sort_order: number
  image?: {
    url?: string
  }
  activeFrom?: Date
  activeUntil?: Date
  optionColor: string
  optionBackgroundColor: string
  optionLink: string
  optionLinkLabel: string

  i18n: LabelFormTranslation[]
  languages: string[]
}

export const LABEL_DEFAULT_STATE: LabelFormState = {
  id: undefined,
  image_id: undefined,
  system_name: '',
  name: '',
  description: '',
  status: 0,
  sort_order: 1,
  image: {
    url: ''
  },
  activeFrom: undefined,
  activeUntil: undefined,
  optionColor: '',
  optionBackgroundColor: '',
  optionLink: '',
  optionLinkLabel: '',
  languages: [],
  i18n: []
}

export const makeLabelFormState = (label?: Labels): LabelFormState => {
  return mergeLeft<LabelFormState>(LABEL_DEFAULT_STATE, {
    ...label,
    languages: label?.i18n?.map((i18n) => i18n.language_code) || [],
  })
}

export const mapStateToApiVariable = (state: LabelFormState): any => ({
  id: state.id,
  image_id: state.image_id ? state.image_id : null,
  system_name: state.system_name,
  name: state.name,
  description: state.description,
  status: state.status,
  sort_order: Number(state.sort_order),
  activeFrom: state.activeFrom ? state.activeFrom.getTime() : null,
  activeUntil: state.activeUntil ? state.activeUntil?.getTime() : null,
  optionColor: state.optionColor ? state.optionColor : null,
  optionBackgroundColor: state.optionBackgroundColor
    ? state.optionBackgroundColor
    : null,
  optionLink: state.optionLink ? state.optionLink : null,
  optionLinkLabel: state.optionLinkLabel ? state.optionLinkLabel : null,
  i18n: state.i18n?.map((i18n) => ({
    language_code: i18n.language_code,
    name: i18n.name,
    description: i18n.description,
    option_link_label: i18n.option_link_label,
    image_id: i18n.image_id
  }))
})

export const mapApiDataToState = (data: Labels): LabelFormState => ({
  id: data.id,
  image_id: data.image_id,
  system_name: data.system_name,
  name: data.name,
  description: data.description,
  status: data.status,
  image: data.image,
  sort_order: data.sort_order,
  activeFrom: data.activeFrom ? new Date(data.activeFrom as Date) : undefined,
  activeUntil: data.activeUntil
    ? new Date(data.activeUntil as Date)
    : undefined,
  optionColor: data.optionColor,
  optionBackgroundColor: data.optionBackgroundColor,
  optionLink: data.optionLink,
  optionLinkLabel: data.optionLinkLabel,
  i18n: data.i18n.map((item) => ({
    language_code: item.language_code,
    name: item.name,
    description: item.description,
    option_link_label: item.option_link_label,
    image_id: item.image_id,
    image: item.image
  })),
  languages: data.i18n?.map((i18n) => i18n.language_code) || []
})
